import './Avatar.scss';

import profile from '@/Assets/profile.png';
import useOnClickOutside from '@/hooks/useClickOutside';
import { Avatar as AvatarComponent, Typography } from 'antd';
import { useRef, useState } from 'react';

interface Props {
	username: string;
	onLogout: () => void
}
const Avatar: React.FC<Props> = ({ username, onLogout }) => {

	const [open, setOpen] = useState(false)

	const toggle = (e: React.MouseEvent) => {
		e.stopPropagation()
		setOpen(prev => !prev)
	}

	const logoutRef = useRef(null)


	useOnClickOutside(logoutRef, () => setOpen(false))
	return (
		<div className='avatar-wrapper' ref={logoutRef}>
			<div className='avatar-container' onClick={toggle}>
				<AvatarComponent src={profile} />
				<Typography.Text>{username}</Typography.Text>
			</div>
			{open && <div className='avatar-menu'>
				<Typography.Text className='menu-item' onClick={onLogout}>Logout</Typography.Text>
			</div>}
		</div>
	);
};

export default Avatar;
